'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.SearchInput = exports.ReferenceInput = exports.AutocompleteInput = exports.NullableBooleanInput = exports.DateTimeInput = exports.DateInput = exports.SelectInput = exports.NumberInput = exports.TextInput = void 0;

var _jsxRuntime = require('react/jsx-runtime');

var _react = _interopRequireDefault(require('react'));

var _reactAdmin = require('react-admin');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(
          target,
          key,
          Object.getOwnPropertyDescriptor(source, key)
        );
      });
    }
  }
  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var standardize = function standardize(Component) {
  return function (props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(
      Component,
      _objectSpread({}, props, {
        variant: 'outlined',
      })
    );
  };
};

var TextInput = standardize(_reactAdmin.TextInput);
exports.TextInput = TextInput;
var NumberInput = standardize(_reactAdmin.NumberInput);
exports.NumberInput = NumberInput;
var SelectInput = standardize(_reactAdmin.SelectInput);
exports.SelectInput = SelectInput;
var DateInput = standardize(_reactAdmin.DateInput);
exports.DateInput = DateInput;
var DateTimeInput = standardize(_reactAdmin.DateTimeInput);
exports.DateTimeInput = DateTimeInput;
var NullableBooleanInput = standardize(_reactAdmin.NullableBooleanInput);
exports.NullableBooleanInput = NullableBooleanInput;
var AutocompleteInput = standardize(_reactAdmin.AutocompleteInput);
exports.AutocompleteInput = AutocompleteInput;
var ReferenceInput = standardize(_reactAdmin.ReferenceInput);
exports.ReferenceInput = ReferenceInput;
var SearchInput = standardize(_reactAdmin.SearchInput);
exports.SearchInput = SearchInput;

//# sourceMappingURL=index.js.map
